// extracted by mini-css-extract-plugin
module.exports = {"btnAnimate":"Index_btnAnimate__9QWo4","btnBlue":"Index_btnBlue__R4E_L","btnYellow":"Index_btnYellow__dEMtU","btnDarkBlue":"Index_btnDarkBlue__bbUcz"};